import { Action, State, StateContext } from '@ngxs/store';
import { ImagePuzzleGameStateModel } from './image-puzzle-game-state.model';
import * as actions from './image-puzzle-game.actions';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';

// @dynamic
@State<ImagePuzzleGameStateModel>({
  name: 'imagePuzzleGameState',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class ImagePuzzleGameState extends PuzzleGameBaseState {
  @Action(actions.InitImagePuzzleGame)
  InitImagePuzzleGame(state: StateContext<ImagePuzzleGameStateModel>, { payload }: actions.InitImagePuzzleGame) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistImagePuzzleState)
  PersistImagePuzzleState(
    state: StateContext<ImagePuzzleGameStateModel>,
    { payload }: actions.PersistImagePuzzleState
  ) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            tiles: payload.tiles,
          }),
        }),
      })
    );
  }
}
